import { html, repeat, when } from '@genesislcap/web-core';
import type { SinkingFundModal } from './sinking-fund-modal';
import {
  formatSinkingFundAmount,
  formatSinkingFundMaturityDate,
} from '../sinking-fund-schedule.util';

export const sinkingFundModalTemplate = html<SinkingFundModal>`
  ${when(
    (x) => x.visible && x.scheduleEntries.length > 0,
    html<SinkingFundModal>`
      <div
        class="sinking-fund-panel"
        style="position: fixed; ${(x) => x.panelStyle}"
        data-test-id="sinking-fund-modal"
        @mouseenter="${(x) => x.handlePanelMouseEnter()}"
        @mouseleave="${(x) => x.handlePanelMouseLeave()}"
      >
        <h3 class="sinking-fund-heading">Sinking Fund</h3>
        <table class="sinking-fund-table">
          <thead>
            <tr>
              <th>Maturity</th>
              <th>Par Amount ($M)</th>
            </tr>
          </thead>
          <tbody>
            ${repeat(
              (x) => x.scheduleEntries,
              html`
                <tr data-test-id="sinking-fund-modal-row">
                  <td>${(x) => formatSinkingFundMaturityDate(x.date)}</td>
                  <td>${(x) => formatSinkingFundAmount(x.amount)}</td>
                </tr>
              `,
            )}
          </tbody>
        </table>
      </div>
    `,
  )}
`;
